import { useGoogleMap } from "@react-google-maps/api";
import { LocateableStop } from "~/api/resources/Itineraries";
import { useEffect, useMemo, useRef, useState } from "react";
import { SolidPolyline } from "./SolidPolyline";
import { DashedPolyline } from "./DashedPolyline";

export const StopPolylines = ({ polyline, id }: LocateableStop) => {
  const [completedPath, setCompletedPath] = useState<google.maps.LatLng[]>([]);
  const percentComplete = usePercentageComplete(id);
  const full_path = useMemo(
    () =>
      !!polyline ? google.maps.geometry.encoding.decodePath(polyline) : [],
    [polyline]
  );
  const polylineRef = useRef<google.maps.Polyline>(null);
  const map = useGoogleMap();

  useEffect(() => {
    const raw_index = (full_path.length - 1) * percentComplete;
    const currentIndex = Math.floor(raw_index);
    const indexProgress = raw_index - currentIndex;
    const start = full_path[currentIndex];
    const end = full_path[currentIndex + 1];
    let current_path = full_path.slice(0, currentIndex);
    if (end) {
      const progress = google.maps.geometry.spherical.interpolate(
        start,
        end,
        indexProgress
      );
      current_path.push(progress);
      map?.setCenter(progress);
    } else {
      current_path = full_path;
    }
    setCompletedPath(current_path);
    polylineRef.current?.setPath(current_path);
  }, [percentComplete, full_path, map]);

  return (
    <>
      <SolidPolyline path={completedPath} ref={polylineRef} showIcon />
      <DashedPolyline path={full_path} />
    </>
  );
};

const usePercentageComplete = (id: number) => {
  // const { activeStop, activePosition } = useMapContext();
  const [percentComplete, setPercentComplete] = useState(0);
  // useEffect(() => {
  //   const handleActiveScroll = () => {
  //     const div = activeStop?.ref.current;
  //     if (div) {
  //       const { top, height } = div.getBoundingClientRect();
  //       const p = 1 - (top + height - activePosition) / height;
  //       setPercentComplete(Math.max(0, Math.min(1, p)));
  //     }
  //   };
  //   if (activeStop?.id === id) {
  //     window.addEventListener("scroll", handleActiveScroll, { passive: true });
  //   } else {
  //     setPercentComplete((p) => Math.round(p));
  //     window.removeEventListener("scroll", handleActiveScroll);
  //   }
  //   return () => {
  //     window.removeEventListener("scroll", handleActiveScroll);
  //   };
  // }, [activeStop, activePosition, id]);
  return percentComplete;
};
